import React from 'react';
import { SectionHeader } from '@leagueplatform/genesis-core-alpha';
import {
  Flex,
  Image,
  genesisStyled,
  css,
} from '@leagueplatform/genesis-commons';

interface CarouselHeadingProps {
  imageSrc?: string;
  title: string;
}

const StyledImage = genesisStyled(Image)(
  css({
    objectFit: 'contain',
    aspectRatio: '1 / 1',
    maxWidth: '32px',
    marginInlineEnd: 'half',
  }),
);

export const CarouselHeading = ({ imageSrc, title }: CarouselHeadingProps) => (
  <Flex alignItems="center">
    {imageSrc && <StyledImage src={imageSrc} alt="" />}
    <SectionHeader title={title} />
  </Flex>
);
